"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _reducer = require("./secret-tree/reducer");

var _reducer2 = require("./secret-list/reducer");

var allSecretsReducer = (0, _redux.combineReducers)({
  getImmediateNodes: _reducer.getImmediateNodes,
  secretList: _reducer2.secretList,
  secretDetails: _reducer2.secretDetails,
  authenticateStepUpMFADetails: _reducer2.authenticateStepUpMFADetails,
  secretTemplateDetails: _reducer2.secretTemplateDetails,
  userDetails: _reducer2.userDetails,
  groupsDetails: _reducer2.groupsDetails,
  secretFileDownload: _reducer2.secretFileDownload,
  secretOTP: _reducer2.secretOTP,
  fetchUserMFAStatus: _reducer2.fetchUserMFAStatus,
  webAuthnAuthenticationInitialData: _reducer2.webAuthnAuthenticationInitialData
});
var _default = allSecretsReducer;
exports.default = _default;